import { Typography } from "@mui/joy";
import { memo } from "react";
import { theme } from "styles/theme";
import { levelType } from "../../../../data/CellComponent";

function TypographyCell({
  text,
  isHeader = false,
  isLabel = false,
  isAlert = false,
  isDimmed = false,
  labelIndex,
  prefixLabelIndex,
  level, // 구버전 대응
  color, // 구버전 대응
  opacity, // 구버전 대응
}: {
  text?: string;
  isHeader?: boolean;
  isLabel?: boolean;
  isAlert?: boolean;
  isDimmed?: boolean;
  labelIndex?: number;
  prefixLabelIndex?: number;
  level?: levelType;
  color?: string;
  opacity?: number;
}) {
  return (
    <Typography
      variant={
        isHeader || level === "h3"
          ? "H3"
          : isAlert || isLabel || color === "danger.solidBg"
            ? "Caption"
            : "Body"
      }
      textColor={
        isLabel || color === "primary.solid"
          ? theme.vars.palette.Content.Highlight
          : isAlert || color === "danger.solidBg"
            ? theme.vars.palette.Content.HighlightWithAlert
            : theme.vars.palette.Content.Strong
      }
      sx={{
        fontWeight: 500,
        ...((isHeader || level === "h3") && {
          wordBreak: "keep-all",
          fontWeight: 700,
        }),
        ...((isLabel || color === "primary.solid") && {
          fontWeight: 700,
        }),
        ...((isDimmed || opacity) && {
          color: theme.vars.palette.Content.Weak,
        }),
      }}
    >
      {`${prefixLabelIndex || ""}${text} ${labelIndex || ""}`}
    </Typography>
  );
}

export default memo(TypographyCell);
